import React, { useContext, useState } from "react";
import "./Login_Signup.css";
import { Form } from "react-bootstrap";
import Blue_White_Gradient_Btn from "../common_components/common_btn/blue_white_gradient_btn/Blue_White_Gradient_Btn";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";
import PasswordChecklist from "react-password-checklist";
import { Login, Register } from "../../utils/apis/login/Login";
import Cookies from "js-cookie";
import { Context } from "../../utils/context";
import classNames from "classnames";
import { RegxExpression } from "../../utils/common";
import Disclaimer_Modal from "../common_components/common_modal/disclaimer_modal/Disclaimer_Modal";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Login_Signup = () => {
  const [activeTab, setActiveTab] = useState("signin");

  const { signin, setSignin, getuserData } = useContext(Context);
  const [verifyError, setVerifyError] = useState("");
  const [modalShowPolicy, setModalShowPolicy] = useState(false);

  const [showForgetPassword, setShowForgetPassword] = useState(false);

  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm();

  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [iconOne, setIconOne] = useState(faEyeSlash);
  const [iconTwo, setIconTwo] = useState(faEyeSlash);

  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    } else if (field === "reenterPassword") {
      setShowPasswordOne(!showPasswordOne);
      setIconTwo(showPasswordOne ? faEyeSlash : faEye);
    }
  };

  const onSubmit = async (data) => {
    if (password !== passwordAgain) {
      setError("re_password", { message: "Passwords do not match" });
      toast.error("Passwords do not match", { position: "bottom-right" });
      return;
    }

    const finalData = new FormData();
    finalData.append("first_name", data?.first_name);
    finalData.append("last_name", data?.last_name);
    finalData.append("refer_code", data?.refer_code);
    finalData.append("country_id", data?.country_id?.value);
    finalData.append("email", data?.email);
    finalData.append("contact_no", data?.contact_no);
    finalData.append("password", data?.password);
    finalData.append("not_us_client", data?.not_us_client);
    finalData.append("accept_terms_and_condition", data?.accept_terms_and_condition);

    const res = await Register(finalData);

    if (res?.success) {
      toast.success("Account created successfully! Redirecting...", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "dark",
      });

      await Cookies.set("stoxwave_security", res?.data?.token);
      setSignin(true);
      getuserData(res?.data?.id);
      setVerifyError("");

      setTimeout(() => {
        navigate("/trade");
        window.location.reload();
      }, 2000);
    } else {
      let errorMsg = "Registration failed. Please try again.";

      if (res?.errors?.both) {
        setError("email", { message: res?.message?.both });
        setError("contact_no", { message: "" });
        errorMsg = res?.message?.both || errorMsg;
      }
      if (res?.errors?.email) {
        setError("email", { message: res?.errors?.email });
        errorMsg = res?.errors?.email || errorMsg;
      }
      if (res?.errors?.contact_no) {
        setError("contact_no", { message: res?.errors?.contact_no });
        errorMsg = res?.errors?.contact_no || errorMsg;
      }
      if (res?.errors?.refer_code) {
        setError("refer_code", { message: res?.errors?.refer_code });
        errorMsg = res?.errors?.refer_code || errorMsg;
      }

      setVerifyError(res.code);
      toast.error(errorMsg, { position: "bottom-right" });
    }
  };

  const onSubmitLogin = async (data) => {
    const res = await Login(data);

    if (res?.success) {
      toast.success("Login successful! Redirecting...", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "dark",
      });

      await Cookies.set("stoxwave_security", res?.data?.token);
      setSignin(true);
      getuserData(res?.data?.id);

      setTimeout(() => {
        navigate("/trade");
      }, 2000);
    } else {
      let errorMsg = "Login failed. Please check your credentials.";

      if (res?.errors?.password) {
        setError("password", { message: res.errors.password });
        errorMsg = res.errors.password;
      }
      if (res?.errors?.email) {
        setError("email", { message: res.errors.email });
        errorMsg = res.errors.email;
      }

      toast.error(errorMsg, { position: "bottom-right" });
    }
  };

  return (
    <section className="auth-page !overflow-y-scroll">
      <ToastContainer position="bottom-right" theme="dark" />

      <div className="auth-container">
        {/* Back Arrow */}
        <button className="back-arrow" onClick={() => navigate("/trade")}>
          <FontAwesomeIcon icon={faArrowLeft} />
        </button>

        {/* Header */}
        <div className="auth-header">
          <h1 className="auth-title">
            {activeTab === "signin" ? "Welcome Back" : "Join StockWave"}
          </h1>
          <p className="auth-subtitle">
            {activeTab === "signin"
              ? "Sign in to continue your trading journey"
              : "Create your account & catch the next big wave"}
          </p>
        </div>

        {/* Tabs */}
        <div className="auth-tabs">
          <button
            className={`tab-btn ${activeTab === "signin" ? "active" : ""}`}
            onClick={() => setActiveTab("signin")}
          >
            Sign In
          </button>
          <button
            className={`tab-btn ${activeTab === "signup" ? "active" : ""}`}
            onClick={() => setActiveTab("signup")}
          >
            Create Account
          </button>
        </div>

        {/* Form Wrapper */}
        <div className={`auth-form-card ${activeTab}`}>
          {activeTab === "signin" && (
            <Form className="auth-form" onSubmit={handleSubmit(onSubmitLogin)}>
              <Form.Group className="form-group floating">
                <Form.Control
                  type="email"
                  placeholder=" "
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                      message: "Invalid email address",
                    },
                  })}
                  className={classNames("floating-input", {
                    "is-invalid": errors?.email,
                  })}
                />
                <Form.Label className="floating-label">Email Address</Form.Label>
                {errors?.email && (
                  <div className="error-text">{errors.email.message}</div>
                )}
              </Form.Group>

              <Form.Group className="form-group floating password-group">
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  placeholder=" "
                  {...register("password", { required: "Password is required" })}
                  className={classNames("floating-input", {
                    "is-invalid": errors?.password,
                  })}
                />
                <Form.Label className="floating-label pb-6">Password</Form.Label>
                <FontAwesomeIcon
                  icon={showPassword ? faEye : faEyeSlash}
                  className="password-toggle-icon"
                  onClick={() => togglePasswordVisibility("password")}
                />
                {errors?.password && (
                  <div className="error-text">{errors.password.message}</div>
                )}
                <span
                  className="forgot-link"
                  onClick={() => navigate("/verify-email")}
                >
                  Forgot password?
                </span>
              </Form.Group>

              <Blue_White_Gradient_Btn
                btn_name="Continue"
                type="submit"
                className="submit-btn"
              />
            </Form>
          )}

          {activeTab === "signup" && (
            <Form className="auth-form" onSubmit={handleSubmit(onSubmit)}>
              <div className="row g-3">
                <div className="col-md-6">
                  <Form.Group className="form-group floating">
                    <Form.Control
                      type="text"
                      placeholder=" "
                      {...register("first_name", { required: "First name is required" })}
                      className={classNames("floating-input", {
                        "is-invalid": errors?.first_name,
                      })}
                      onKeyDown={(e) => {
                        if (!RegxExpression.name.test(e.key)) e.preventDefault();
                      }}
                    />
                    <Form.Label className="floating-label">First Name</Form.Label>
                    {errors?.first_name && (
                      <div className="error-text">{errors.first_name.message}</div>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="form-group floating">
                    <Form.Control
                      type="text"
                      placeholder=" "
                      {...register("last_name", { required: "Last name is required" })}
                      className={classNames("floating-input", {
                        "is-invalid": errors?.last_name,
                      })}
                      onKeyDown={(e) => {
                        if (!RegxExpression.name.test(e.key)) e.preventDefault();
                      }}
                    />
                    <Form.Label className="floating-label">Last Name</Form.Label>
                    {errors?.last_name && (
                      <div className="error-text">{errors.last_name.message}</div>
                    )}
                  </Form.Group>
                </div>
              </div>

              <Form.Group className="form-group floating">
                <Form.Control
                  type="email"
                  placeholder=" "
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                      message: "Invalid email format",
                    },
                  })}
                  className={classNames("floating-input", {
                    "is-invalid": errors?.email,
                  })}
                />
                <Form.Label className="floating-label">Email Address</Form.Label>
                {errors?.email && (
                  <div className="error-text">{errors.email.message}</div>
                )}
              </Form.Group>

              <Form.Group className="form-group floating">
                <Form.Control
                  type="tel"
                  placeholder=" "
                  {...register("contact_no", {
                    required: "Contact number is required",
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message: "Must be exactly 10 digits",
                    },
                  })}
                  className={classNames("floating-input", {
                    "is-invalid": errors?.contact_no,
                  })}
                />
                <Form.Label className="floating-label">Contact Number</Form.Label>
                {errors?.contact_no && (
                  <div className="error-text">{errors.contact_no.message}</div>
                )}
              </Form.Group>

              <Form.Group className="form-group floating">
                <Form.Control
                  type="text"
                  placeholder=" "
                  {...register("refer_code")}
                  className="floating-input"
                />
                <Form.Label className="floating-label">Referral Code (Optional)</Form.Label>
              </Form.Group>

              <Form.Group className="form-group floating password-group">
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  placeholder=" "
                  {...register("password", {
                    required: "Password is required",
                    minLength: { value: 8, message: "Minimum 8 characters" },
                    pattern: {
                      value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                      message: "Must contain uppercase, lowercase & number",
                    },
                  })}
                  className={classNames("floating-input", {
                    "is-invalid": errors?.password,
                  })}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    clearErrors("password");
                  }}
                />
                <Form.Label className="floating-label pb-6">Password</Form.Label>
                <FontAwesomeIcon
                  icon={iconOne}
                  className="password-toggle-icon"
                  onClick={() => togglePasswordVisibility("password")}
                />
                {errors?.password && (
                  <div className="error-text">{errors.password.message}</div>
                )}

                {password && (
                  <PasswordChecklist
                    className="password-checklist"
                    rules={["minLength", "specialChar", "number", "capital", "match"]}
                    minLength={8}
                    value={password}
                    valueAgain={passwordAgain}
                    messages={{
                      minLength: "≥ 8 characters",
                      specialChar: "≥ 1 special character",
                      number: "≥ 1 number",
                      capital: "≥ 1 uppercase",
                      match: "Passwords match",
                    }}
                    iconSize={14}
                    style={{ marginTop: "0.8rem", fontSize: "0.9rem" }}
                  />
                )}
              </Form.Group>

              <Form.Group className="form-group floating password-group">
                <Form.Control
                  type={showPasswordOne ? "text" : "password"}
                  placeholder=" "
                  {...register("re_password", {
                    required: "Confirm password",
                    validate: (val) => val === getValues("password") || "Passwords do not match",
                  })}
                  className={classNames("floating-input", {
                    "is-invalid": errors?.re_password,
                  })}
                  onChange={(e) => {
                    setPasswordAgain(e.target.value);
                    clearErrors("re_password");
                  }}
                />
                <Form.Label className="floating-label pb-6">Confirm Password</Form.Label>
                <FontAwesomeIcon
                  icon={iconTwo}
                  className="password-toggle-icon"
                  onClick={() => togglePasswordVisibility("reenterPassword")}
                />
                {errors?.re_password && (
                  <div className="error-text">{errors.re_password.message}</div>
                )}
              </Form.Group>

              {/* Checkboxes */}
              <div className="checkbox-group">
                <Form.Check
                  type="checkbox"
                  id="not-us-client"
                  label="I confirm I am not a US citizen/resident for tax purposes"
                  {...register("not_us_client", { required: "This is required" })}
                  className={classNames({ "is-invalid": errors.not_us_client })}
                />
                {errors.not_us_client && (
                  <div className="error-text">{errors.not_us_client.message}</div>
                )}

                <Form.Check
                  type="checkbox"
                  id="terms"
                  label={
                    <span>
                      I accept the{" "}
                      <span
                        className="policy-link"
                        onClick={(e) => {
                          e.stopPropagation();
                          setModalShowPolicy(true);
                        }}
                      >
                        Investment Policy
                      </span>
                    </span>
                  }
                  {...register("terms", { required: "You must accept terms" })}
                  className={classNames({ "is-invalid": errors.terms })}
                />
                {errors.terms && <div className="error-text">{errors.terms.message}</div>}

                <Form.Check
                  type="checkbox"
                  label="I accept all terms & conditions"
                  {...register("accept_terms_and_condition", {
                    required: "You must accept all terms",
                  })}
                  className={classNames({ "is-invalid": errors.accept_terms_and_condition })}
                />
                {errors.accept_terms_and_condition && (
                  <div className="error-text">
                    {errors.accept_terms_and_condition.message}
                  </div>
                )}
              </div>

              <Blue_White_Gradient_Btn
                btn_name="Create Account"
                type="submit"
                className="submit-btn"
              />
            </Form>
          )}
        </div>
      </div>

      <Disclaimer_Modal
        show={modalShowPolicy}
        onHide={() => setModalShowPolicy(false)}
      />
    </section>
  );
};

export default Login_Signup;